import React from 'react';
import _ from 'lodash';
import { formatMoney } from '../../utils/money';

const TotalQuantityText = ({ total, currency }) => {
  const generalTotal = _.values(total).reduce(
    (tt, current) => tt + _.values(current).reduce((t, c) => c + t, 0),
    0,
  );

  return <span>{formatMoney(generalTotal, currency || 'EUR')}</span>;
};

export default TotalQuantityText;
